import React, { Component } from 'react';

import '../assets/stylesheets/NoMatch.css';

class NoMatch extends Component {

  constructor(props, context){
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.context.router.push(`/`);
  }

  render() {
    return (
      <div className="not-found">
        <div className="sad-character" onClick={this.handleClick}/>
      </div>
    );
  }
}

NoMatch.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default NoMatch;



/** WEBPACK FOOTER **
 ** ./src/pages/NoMatch.js
 **/